import { IBook } from "@/interface/IBook";
import styles from "./index.module.scss";
import classNames from "classnames";
import BookCard from "../BookCard";
import Row from "@/components/Row";
import Col from "@/components/Row/Col";

export type BookCardListProps = {
  title?: string;
  list: IBook[];
  handleBookLink?: (bookInfo: IBook) => string;
} & React.HTMLAttributes<HTMLDivElement>;

const BookCardList = (props: BookCardListProps) => {
  const { list, title, handleBookLink, className, ...restProps } = props;

  if (!list?.length) {
    return null;
  }

  return (
    <div className={classNames(styles.container, className)} {...restProps}>
      {title && (
        <div className={classNames(styles.title, "mb16 pb4 t_h6 ell c_l")}>
          {title}
        </div>
      )}
      <Row
        className={styles.list}
        gutter={{
          md: 16,
          xxs: 16,
        }}
      >
        {list.map((book) => {
          return (
            <Col
              key={book.bookId}
              span={24}
              md={{
                span: 12,
              }}
            >
              <BookCard
                handleBookLink={handleBookLink}
                className={styles.item}
                bookInfo={book}
              />
            </Col>
          );
        })}
      </Row>
    </div>
  );
};

export default BookCardList;
